<script lang="ts" setup>
const disableChat = useChat().disableChat;
</script>

<template>
	<NuxtPage />
	<div
		v-show="!disableChat"
		id="tn-chat-wrapper"
	>
		<div
			id="tn-chat"
			data-auto-open="false"
			data-auto-start="false"
		></div>
	</div>
</template>
